var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-content"},[_c('vue-scroll',[_c('router-view'),_c('Footer'),(!_vm.isMobile)?_c('Side'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }